export default "/assets/surf.png";